import type { IntlShape } from 'react-intl'
import type { WeddingGiftCategory } from 'weddings/api/weddings'

export function getWeddingGiftCategoryLabel(intl: IntlShape, category: WeddingGiftCategory): string {
  switch (category) {
    case 'HOTEL':
      return intl.formatMessage({ defaultMessage: 'Hotels', id: '4hcRf9tF9YmlW8rqxBIk', description: 'Category label for hotel wedding registry gift items.' })
    case 'FLIGHT':
      return intl.formatMessage({ defaultMessage: 'Flights', id: 'up2Rc-vUGu2frsk9IT-_', description: 'Category label for flight wedding registry gift items.' })
    case 'EXPERIENCE':
      return intl.formatMessage({ defaultMessage: 'Experiences', id: 'bpuDQ2K0r-KLJCPrtsCw', description: 'Category label for experience wedding registry gifts.' })
    case 'CRUISE':
      return intl.formatMessage({ defaultMessage: 'Cruises', id: '9XNGqlzfnwyjuUwUplb7', description: 'Category label for cruise wedding registry gift items.' })
    case 'TOUR':
      return intl.formatMessage({ defaultMessage: 'Tours', id: 'cY6WCatYEiyM6aIzJpLf', description: 'Category label for tour wedding registry gift items.' })
    case 'ANY':
      return intl.formatMessage({ defaultMessage: 'Any', id: 'z60k1fSGJdyXskNuMj3e', description: 'Category label for flexible wedding registry gift cards.' })
  }
}
